import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ClaimService } from '@fitness-force/api';
import { ServiceBehaviour, StaffStatus } from '@fitness-force/enum';
import { Claim, GetPlanMasterByIdResponse, PlanBreakUpCalculation, PlanBreakUpCalculationResponse, PlanMasterServices, STAFFINTERFACE, ServiceBreakUp } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { AssignedToComponent } from 'libs/common/assigned-to/src/lib/assigned-to/assigned-to.component';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { BehaviorSubject, Observable, combineLatestWith } from 'rxjs';

@Component({
  selector: 'change-session-owner',
  templateUrl: './change-session-owner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    AssignedToComponent,
    ReactiveFormsModule,
    ButtonModule,
    TranslateModule
  ]
})
export class ChangeSessionOwnerComponent implements OnInit {
  @Input("planBreakUp") planBreakUpCalculation: PlanBreakUpCalculation ={} as PlanBreakUpCalculation;
  @Input("planMaster") planMaster: GetPlanMasterByIdResponse ={} as GetPlanMasterByIdResponse;
  @Input('visible') showModel = false;
  @Output() closeChangeSessionOwnerDialogEvent : EventEmitter<{hidePopup: boolean;planBreakUpCalculation: PlanBreakUpCalculation}>  = new EventEmitter();
  
  _sessionOwner = new BehaviorSubject<number[]>([0]);
  claim$: Observable<Claim[]> = new Observable();
  changeSessionOwnerForm: UntypedFormGroup = {} as UntypedFormGroup;
  
  constructor( private claimService: ClaimService, private store: Store,
    private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.changeSessionOwnerForm = this.fb.group({});
    this.createSessionOwner();
    this.claim$ = this.claimService.GetClaim(environment.BASE_URL);
    this.ValidSessionOwners();
  }

  createSessionOwner() {
    if (this.planBreakUpCalculation != null) {
      this.planBreakUpCalculation.charging_today?.service_non_recurring?.services?.forEach(
        (value: ServiceBreakUp) => {
          this.changeSessionOwnerForm.addControl('service_session_owner_' + value.id.toString(),new UntypedFormControl(value.session_owner_id, []));
        }
      );
      this.planBreakUpCalculation?.charging_today?.service_first_charge?.services?.forEach(
        (value: ServiceBreakUp) => {
          this.changeSessionOwnerForm.addControl('service_session_owner_' + value.id.toString(),new UntypedFormControl(value.session_owner_id, []));
        }
      );
    }
  }

  ValidSessionOwners() {
    let claim: Claim[] = {} as Claim[];
    let staffs: STAFFINTERFACE[] = [];
    let validStaff: number[] = [];
    this.claim$.pipe(combineLatestWith(this.store.select(STAFF_STATE)))
      .subscribe(([objClaim, objStaff]) => {
        claim = objClaim;
        staffs = objStaff.staffList;
        if (staffs.length > 0) {
          staffs.forEach((stf) => {
            if ((stf.status === StaffStatus.Active || stf.status.toString() === StaffStatus[StaffStatus.Active])) {
              validStaff.push(stf.id);
            }
          });
          this._sessionOwner.next(validStaff);
          
        }
      });
  }

  isSessionOwnerRequired(oData: GetPlanMasterByIdResponse, serviceId: number) {
    var sessionOwnerNotfound = true;
    oData.recurring_services.forEach((oService: PlanMasterServices) => {
      if (oService.id == serviceId && (oService.behaviour == ServiceBehaviour.AppointmentPackage || oService.behaviour.toString() == ServiceBehaviour[ServiceBehaviour.AppointmentPackage])
      ) {
        sessionOwnerNotfound = false;
      }
    });

    oData.non_recurring_services.forEach((oService: PlanMasterServices) => {
      if (
        oService.id == serviceId &&
        (oService.behaviour == ServiceBehaviour.AppointmentPackage ||
          oService.behaviour.toString() ==
          ServiceBehaviour[ServiceBehaviour.AppointmentPackage])
      ) {
        sessionOwnerNotfound = false;
      }
    });
    return sessionOwnerNotfound;
  }

  SetSessionOwner() {
      this.planBreakUpCalculation?.charging_today?.service_non_recurring?.services?.forEach(
        (value) => {
          if (this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()] 
              && this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value
              && this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value.id !=undefined ) {
            value.session_owner_id = this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value.id;
          }
          else{
            value.session_owner_id= 0;
          }
        }
      );

      this.planBreakUpCalculation?.charging_today?.service_first_charge?.services?.forEach(
        (value) => {
          if (this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()] 
          && this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value
          && this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value.id != undefined  ) {
            value.session_owner_id =this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value.id;
          }
          else{
            value.session_owner_id= 0;
          }
        }
      );

      this.planBreakUpCalculation.charging_recurring.services.forEach(
        (value) => {
          if (this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()] 
          && this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value
          && this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value.id != undefined ) {
            value.session_owner_id =this.changeSessionOwnerForm.controls['service_session_owner_' + value.id.toString()].value.id;
          }
          else{
            value.session_owner_id= 0;
          }
        }
      );
  }

  getServiceName(oData: GetPlanMasterByIdResponse, serviceId: number) {
    var data = '';
    oData.recurring_services.forEach((oService: PlanMasterServices) => {
      if (oService.id == serviceId) {
        data = oService.name_primary_language;
      }
    });

    oData.non_recurring_services.forEach((oService: PlanMasterServices) => {
      if (oService.id == serviceId) {
        data = oService.name_primary_language;
      }
    });
    return data;
  }

  closeModel()
  {
    this.SetSessionOwner();
    this.showModel=false;
    this.closeChangeSessionOwnerDialogEvent.emit({hidePopup:true, planBreakUpCalculation:this.planBreakUpCalculation})
  }

  selectSessionOwner()
  {
    this.SetSessionOwner();
    this.showModel=false;
    this.closeChangeSessionOwnerDialogEvent.emit({hidePopup:true, planBreakUpCalculation:this.planBreakUpCalculation})
  }

  getSessionOwnerFC(ctlName: string): UntypedFormControl {
    return this.changeSessionOwnerForm.get(ctlName) as UntypedFormControl;
  }

  getSesionOwnerId(ctlName: string)
  {
    return new BehaviorSubject<number>(this.changeSessionOwnerForm.get(ctlName)?.value ? this.changeSessionOwnerForm.get(ctlName)?.value  : 0);
  }

}
